__webpack_require__.p = "/assets/base/";